export default __webpack_public_path__ + "static/media/logo-icon-only.3b0c424e.svg";